'use client'

import React, { useEffect } from 'react'
import { useThemeStore, Theme } from '@/stores/theme'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme, setTheme } = useThemeStore()

  useEffect(() => {
    const savedTheme = localStorage.getItem('cms_theme') as Theme | null
    if (savedTheme) {
      setTheme(savedTheme)
    }
  }, [setTheme])

  useEffect(() => {
    const root = document.documentElement
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const applyTheme = () => {
      let activeTheme = theme
      if (theme === 'system') {
        activeTheme = mediaQuery.matches ? 'dark' : 'light'
      }
      root.setAttribute('data-theme', activeTheme)
    }

    applyTheme()
    mediaQuery.addEventListener('change', applyTheme)
    return () => mediaQuery.removeEventListener('change', applyTheme)
  }, [theme])

  return <>{children}</>
}
